import { get } from 'lodash';

export default state => get(state, 'startup.loaded', false);